import {
    List,
    EditButton,
    Datagrid,
    TextField,
    BooleanField,
    Filter,
    SelectInput,
    useListContext,
    TopToolbar,
} from 'react-admin';
import FormattedDateTimeField from '../../common/FormattedDateTimeField';
import ThumbnailField from "../../common/ThumbnailField";
import useIsPermission from '../../hooks/useIsPermission';
import PermissionBasedActions from '../../common/PermissionBasedActionsButton';
import { BANNER_TYPE, HIDDEN } from '../../common/constants';
import { BannerCategoryAutoComplete } from './BannerCategoryAutoComplete';
import ConfirmDeleteButton from '../../common/ConfirmDeleteButton';
import { useNavigate } from 'react-router';
import { Link } from 'react-router-dom';
import { Add } from '@mui/icons-material';
import { Typography } from '@mui/material';

const ListFilter = (props: any) => (
    <Filter {...props}>
        <BannerCategoryAutoComplete label="Banner Categories" source="category_id" alwaysOn reference="banner_categories" />
        <SelectInput source="type" label={"Type"} choices={BANNER_TYPE} alwaysOn />
        <SelectInput source="hidden" label={"Hidden"} choices={HIDDEN} alwaysOn />
    </Filter>
);

const ListActions = () => {
    const { filterValues } = useListContext();
    const query = new URLSearchParams(filterValues).toString();

    return (
        <TopToolbar>
            <>
                <Link
                    to={`/banners/create?${query}`}
                    style={{ textDecoration: 'none' }}
                >
                    <Add />   <Typography variant="button">Create</Typography>
                </Link>
            </>
        </TopToolbar>
    );
};


const BannerList = () => {
    const { isUpdatable, isWritable, isDeletable } = useIsPermission("BANNERS");
    return (
        <div>
            <List
                actions={<ListActions />}
                filters={<ListFilter />}
                sort={{ field: 'display_order', order: 'ASC' }}
                queryOptions={{
                    refetchOnWindowFocus: false,
                    refetchOnReconnect: false,
                }}
            >
                <Datagrid>
                    <ThumbnailField source="image" />
                    <TextField source="displayOrder" />
                    <TextField source="redirectUrl" />
                    <TextField source="type" />
                    <BooleanField source="hidden" />
                    <FormattedDateTimeField source="createdAt" />
                    {isUpdatable &&
                        <EditButton />
                    }
                    {isDeletable &&
                        <ConfirmDeleteButton />
                    }
                </Datagrid>
            </List>
        </div>
    );
};
export default BannerList;
